import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ElasticsearchAnalyzeTokenInlineResultComponent } from '@libs/shared/ui/elasticsearch-term-analyzer/elasticsearch-analyze-token-inline-result.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { SearchBarComponent } from '@libs/shared/ui/search-bar/search-bar/search-bar.component';
import { ElasticsearchAnalyzerType, SearchService } from '@libs/shared/api';
import { analyzerTranslation } from '@libs/shared/ui/elasticsearch-term-analyzer/constant';

@Component({
  selector: 'app-elasticsearch-single-analyzer',
  standalone: true,
  imports: [
    ElasticsearchAnalyzeTokenInlineResultComponent,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    SearchBarComponent
],
  template: `
    <div class="flex flex-col gap-2 w-full">
      <mat-form-field class="flex-none" [subscriptSizing]="'dynamic'">
        <mat-label>Analyzer</mat-label>
        <mat-select [(value)]="selectedAnalyzer">
          @for (analyzer of analyzers; track analyzer) {
            <mat-option
              [value]="analyzer.value">
              {{ analyzer.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <app-search-bar
        class="flex-auto"
        placeholder="분석할 텍스트를 입력 후 엔터를 누르세요."
        (bySearch)="onTypeTerm($event)"
        (byEnterPressed)="onAnalyzeTerm()" />
    </div>
    <div class="p-4">
      <app-elasticsearch-analyze-token-inline-result
        [keyword]="keyword"
        [analyzer]="selectedAnalyzer" />
    </div>
    `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElasticsearchSingleAnalyzerComponent {
  constructor(private _searchService: SearchService) {}

  term = '';
  keyword = '';

  selectedAnalyzer = ElasticsearchAnalyzerType.KoreanAnalyzerSearch;
  analyzers = Object.keys(ElasticsearchAnalyzerType).map(key => {
    return {
      label: `${analyzerTranslation[key]} [${key}]`,
      value: ElasticsearchAnalyzerType[key],
    };
  });

  onTypeTerm($event: string) {
    this.term = $event;
  }

  onAnalyzeTerm() {
    this.keyword = this.term;
  }
}
